import Button from './button.component';

export default Button;
